(function () {
  function buildAddToCartFormData(form) {
    var formData = new FormData();
    form.querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(function (x) {
      if (!x.closest('product-sticky-panel')) {
        if (x.type === 'file') {
          if (x.files[0]) {
            formData.append(x.name, x.files[0]);
          }
        } else {
          formData.append(x.name, x.value);
        }
      }
    });
    return formData;
  }

  function fixSellingPlanInFormData(form, formData) {
    var sellingPlanEl = form.querySelector('product-selling-plan');
    formData.delete('selling_plan');
    if (!sellingPlanEl) return;

    var checkedOpt = sellingPlanEl.querySelector('[name="purchase_option"]:checked');
    var savedPurchaseOption = checkedOpt ? checkedOpt.value : '';
    var savedSellingPlan = '';
    var planSelect = sellingPlanEl.querySelector('select');
    var sellingPlanInput = sellingPlanEl.querySelector('[name="selling_plan"]');
    var prepaidChecked = sellingPlanEl.querySelector('[name="prepaid_purchase_option"]:checked');
    var prepaidSelect = sellingPlanEl.querySelector('select.prepaidPlans');

    if (checkedOpt && checkedOpt.value !== '' && checkedOpt.value !== 'onetime') {
      if (prepaidChecked && prepaidSelect && prepaidSelect.value) {
        savedSellingPlan = prepaidSelect.value;
      } else {
        savedSellingPlan = (planSelect && planSelect.value) ? planSelect.value :
          (sellingPlanInput && sellingPlanInput.value) ? sellingPlanInput.value : '';
      }
    }

    if (savedPurchaseOption && savedPurchaseOption !== '' && savedPurchaseOption !== 'onetime') {
      if (savedSellingPlan) {
        formData.append('selling_plan', savedSellingPlan);
      } else if (planSelect && planSelect.value) {
        formData.append('selling_plan', planSelect.value);
      }
    } else if (prepaidChecked && prepaidSelect && prepaidSelect.value) {
      formData.append('selling_plan', prepaidSelect.value);
    }
  }

  function isOneTimePurchaseForm(form) {
    var sellingPlanEl = form.querySelector('product-selling-plan');
    if (!sellingPlanEl) return true;
    var checkedOpt = sellingPlanEl.querySelector('[name="purchase_option"]:checked');
    if (!checkedOpt) return true;
    return checkedOpt.value === '' || checkedOpt.value === 'onetime';
  }

  window.cbdmdBuildAddToCartFormData = buildAddToCartFormData;
  window.cbdmdFixSellingPlanInFormData = fixSellingPlanInFormData;
  window.cbdmdIsOneTimePurchaseForm = isOneTimePurchaseForm;

  window.cbdmdSubmitAddToCartForm = function (form, submitFn) {
    var formData = buildAddToCartFormData(form);
    fixSellingPlanInFormData(form, formData);
    var crossUpSell = form.querySelector('cross-up-sells');
    if (crossUpSell && window.showCrossUpSellPopup && isOneTimePurchaseForm(form) && !formData.get('selling_plan')) {
      window.showCrossUpSellPopup(formData, submitFn);
      return;
    }
    submitFn(formData);
  };

  var popup = document.getElementById('subscribe-save-popup');
  if (!popup) return;

  var overlay = popup.querySelector('.subscribe-save-popup__overlay');
  var closeBtn = popup.querySelector('.subscribe-save-popup__close');
  var titleEl = popup.querySelector('.subscribe-save-popup__title');
  var imageEl = popup.querySelector('.subscribe-save-popup__image');
  var productTitleEl = popup.querySelector('.subscribe-save-popup__product-title');
  var variantEl = popup.querySelector('.subscribe-save-popup__variant');
  var salePriceEl = popup.querySelector('.subscribe-save-popup__price-sale');
  var comparePriceEl = popup.querySelector('.subscribe-save-popup__price-compare');
  var selectEl = popup.querySelector('.subscribe-save-popup__select');
  var subscribeBtn = popup.querySelector('.subscribe-save-popup__subscribe');
  var declineBtn = popup.querySelector('.subscribe-save-popup__decline');
  var dialogEl = popup.querySelector('.subscribe-save-popup__dialog');

  var pendingFormData = null;
  var pendingSubmit = null;
  var oneMonthLabel = "1 month";

  function getProductMain() {
    return document.querySelector('product-main.product-main-element') || document.querySelector('product-main');
  }

  function getCustomerTags() {
    var el = document.querySelector('[type="application/json"][data-customer-json]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function isVeteranCustomer(tags) {
    var specialTags = ['vet', 'firstresponder', 'med', 'Medical', 'First Responder', 'Veteran'];
    return tags.some(function (tag) {
      return specialTags.indexOf(tag) > -1;
    });
  }

  function getFilteredGroups(productData) {
    var groups = (productData.sellingPlanGroups || []).filter(function (g) {
      return g.app_id == '5859381';
    });
    var veteran = isVeteranCustomer(getCustomerTags());
    if (veteran) {
      return groups.filter(function (g) { return g.name.indexOf('Veteran') > -1; });
    }
    return groups.filter(function (g) {
      return g.name.indexOf('Veteran') === -1;
    });
  }

  function sortGroups(groups) {
    return groups.slice().sort(function (a, b) {
      var aIsPrepaid = a.name.indexOf('Prepaid') > -1;
      var bIsPrepaid = b.name.indexOf('Prepaid') > -1;
      return (aIsPrepaid ? 1 : 0) - (bIsPrepaid ? 1 : 0);
    });
  }

  function planLabel(plan, group) {
    if (group && group.name.indexOf('Prepaid') > -1) {
      var prepaidValue = plan.options && plan.options[0] ? (plan.options[0].value || '').trim() : '';
      return prepaidValue ? 'Prepaid for ' + prepaidValue : (plan.name || '').trim();
    }
    var label = (plan.name || '').trim();
    if (label.replace('Delivered every', '').trim() === 'month') {
      return 'Delivered every ' + oneMonthLabel;
    }
    return label;
  }

  function isThirtyDayPlan(plan) {
    var planName = (plan.name || '').toLowerCase();
    var planOption = plan.options && plan.options[0] ? (plan.options[0].value || '').toLowerCase() : '';
    var looksLikeThirty = planName.indexOf('30') > -1 || planOption.indexOf('30') > -1 ||
      planName.indexOf('thirty') > -1 || planOption.indexOf('thirty') > -1;
    var looksLikeOther = ['60', '90', '120'].some(function (n) {
      return planName.indexOf(n) > -1 || planOption.indexOf(n) > -1;
    });
    return looksLikeThirty && !looksLikeOther;
  }

  function getPlansForVariant(variant, groups) {
    var plans = [];
    sortGroups(groups).forEach(function (group) {
      group.selling_plans.forEach(function (plan) {
        var allocation = (variant.selling_plan_allocations || []).find(function (a) {
          return a.selling_plan_id == plan.id;
        });
        if (allocation) {
          plans.push({
            id: plan.id,
            label: planLabel(plan, group),
            allocation: allocation,
            isThirtyDay: isThirtyDayPlan(plan),
            isPrepaid: group.name.indexOf('Prepaid') > -1
          });
        }
      });
    });
    return plans;
  }

  function getDefaultPlanId(plans) {
    var thirtyDay = plans.find(function (p) { return p.isThirtyDay && !p.isPrepaid; });
    return (thirtyDay || plans.find(function (p) { return !p.isPrepaid; }) || plans[0] || {}).id || '';
  }

  function getDiscountPercent(groups) {
    var group = groups.find(function (g) { return g.name.indexOf('Prepaid') === -1; }) || groups[0];
    if (!group || !group.selling_plans || !group.selling_plans[0]) return 25;
    var adjustments = group.selling_plans[0].price_adjustments;
    if (adjustments && adjustments.length > 0 && adjustments[0].value) {
      return adjustments[0].value;
    }
    return 25;
  }

  function getVariantImage(variant, productData) {
    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (variant.featured_media && productData.media) {
      var media = productData.media.find(function (m) { return m.id == variant.featured_media.id; });
      if (media && media.preview_image && media.preview_image.src) {
        return media.preview_image.src;
      }
    }
    if (productData.media && productData.media[0] && productData.media[0].preview_image) {
      return productData.media[0].preview_image.src;
    }
    return '';
  }

  function formatPrice(cents) {
    return $s.formatMoney(cents).replace('.00', '');
  }

  function populateSelect(plans, selectedPlanId) {
    selectEl.innerHTML = plans.map(function (plan) {
      var selected = plan.id == selectedPlanId ? ' selected' : '';
      return '<option value="' + plan.id + '"' + selected + '>' + plan.label + '</option>';
    }).join('');
    selectEl.value = String(selectedPlanId);
  }

  function updatePricesFromPlan(planId, plans, variant) {
    var plan = plans.find(function (p) { return String(p.id) === String(planId); });
    var allocation = plan ? plan.allocation : null;
    var salePrice = allocation ? allocation.price : variant.price;
    salePriceEl.textContent = formatPrice(salePrice);
    comparePriceEl.textContent = formatPrice(variant.price);
  }

  function lockPageScroll() {
    document.documentElement.classList.add('subscribe-save-popup-open');
    document.body.classList.add('subscribe-save-popup-open');
    if (window.$s && typeof $s.hideScroll === 'function') {
      $s.hideScroll();
    }
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('subscribe-save-popup-open');
    document.body.classList.remove('subscribe-save-popup-open');
    if (window.$s && typeof $s.showScroll === 'function') {
      $s.showScroll();
    }
  }

  function hidePopup() {
    popup.hidden = true;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    unlockPageScroll();
    pendingFormData = null;
    pendingSubmit = null;
  }

  function showPopup(formData, crossUpSellOrSubmitFn, maybeSubmitFn) {
    var submitFn = typeof maybeSubmitFn === 'function' ? maybeSubmitFn : crossUpSellOrSubmitFn;
    if (typeof submitFn !== 'function') {
      return;
    }
    var productMain = getProductMain();
    if (!productMain || !productMain.productData) {
      submitFn(formData);
      return;
    }

    var productData = productMain.productData;
    if (productData.requiresSellingPlan) {
      submitFn(formData);
      return;
    }

    var variantId = formData.get('id');
    var variant = productData.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });

    if (!variant && productMain.getCurrentVariant) {
      try {
        variant = productMain.getCurrentVariant();
      } catch (e) {
        variant = null;
      }
    }

    if (!variant) {
      submitFn(formData);
      return;
    }

    var groups = getFilteredGroups(productData);
    var plans = getPlansForVariant(variant, groups);
    if (!plans.length) {
      submitFn(formData);
      return;
    }

    pendingFormData = formData;
    pendingSubmit = submitFn;

    var defaultPlanId = getDefaultPlanId(plans);
    var discount = getDiscountPercent(groups);

    titleEl.textContent = 'Would you like to subscribe & save ' + discount + '%?';
    productTitleEl.textContent = popup.dataset.productTitle || '';
    variantEl.textContent = variant.title === 'Default Title' ? '' : variant.title;

    var imageSrc = getVariantImage(variant, productData);
    if (imageSrc) {
      imageEl.src = imageSrc;
      imageEl.alt = popup.dataset.productTitle || '';
      imageEl.hidden = false;
    } else {
      imageEl.hidden = true;
    }

    populateSelect(plans, defaultPlanId);
    updatePricesFromPlan(defaultPlanId, plans, variant);

    selectEl.onchange = function () {
      updatePricesFromPlan(selectEl.value, plans, variant);
    };

    popup.hidden = false;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    lockPageScroll();
    if (dialogEl) {
      dialogEl.scrollTop = 0;
    }
    closeBtn.focus();
  }

  function submitWithPlan() {
    if (!pendingFormData || !pendingSubmit) return;
    var data = pendingFormData;
    var submitFn = pendingSubmit;
    hidePopup();
    data.delete('selling_plan');
    data.append('selling_plan', selectEl.value);
    $s.showLoadingOverlay();
    submitFn(data);
  }

  function submitOneTime() {
    if (!pendingFormData || !pendingSubmit) return;
    var data = pendingFormData;
    var submitFn = pendingSubmit;
    hidePopup();
    data.delete('selling_plan');
    $s.showLoadingOverlay();
    submitFn(data);
  }

  subscribeBtn.addEventListener('click', submitWithPlan);
  declineBtn.addEventListener('click', submitOneTime);
  closeBtn.addEventListener('click', submitOneTime);
  overlay.addEventListener('click', submitOneTime);

  popup.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      submitOneTime();
    }
  });

  popup.addEventListener('wheel', function (e) {
    if (dialogEl && !dialogEl.contains(e.target)) {
      e.preventDefault();
    }
  }, { passive: false });

  popup.addEventListener('touchmove', function (e) {
    if (dialogEl && !dialogEl.contains(e.target)) {
      e.preventDefault();
    }
  }, { passive: false });

  window.showCrossUpSellPopup = showPopup;
})();
